// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {Carousel, CarouselItem } from 'element-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '../static/font/font.css';
import '../static/css/style.css';
import 'element-ui/lib/theme-chalk/index.css'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.component(CollapseTransition.name, CollapseTransition);

Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false
Vue.prototype.$openNewPage = (path, query) => {
  const { href } = router.resolve({path, query});
  window.open(`${href}`, '_blank');
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js